import React from 'react';
import RisksContent from '../features/risks';

const Risks = () => {
  return <RisksContent />;
};

export default Risks;
